import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20 pb-8" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "py-10 flex justify-between items-center" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex justify-between items-center mb-6" }
const _hoisted_6 = { class: "text-3xl font-bold" }
const _hoisted_7 = {
  key: 0,
  class: "block text-sm font-bold text-next-stato-2 uppercase border-2 border-next-stato-2 py-2 px-4 w-48 text-center"
}
const _hoisted_8 = { class: "grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col pb-3 grow"
}
const _hoisted_10 = { class: "relative flex items-center" }
const _hoisted_11 = {
  key: 1,
  class: "grid grid-cols-2 col-span-2"
}
const _hoisted_12 = {
  key: 2,
  class: "pb-3"
}
const _hoisted_13 = { class: "grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5 pb-3" }
const _hoisted_14 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_15 = { class: "flex flex-col pb-3" }
const _hoisted_16 = { class: "flex flex-col pb-3 grow" }
const _hoisted_17 = { class: "flex flex-col mb-3" }
const _hoisted_18 = { class: "flex flex-col text-sm" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "font-bold" }
const _hoisted_21 = {
  key: 1,
  class: "flex items-center justify-between"
}
const _hoisted_22 = { class: "flex flex-col" }
const _hoisted_23 = { class: "font-bold" }
const _hoisted_24 = { class: "font-bold" }
const _hoisted_25 = { class: "font-bold" }
const _hoisted_26 = { class: "flex flex-col mb-3" }
const _hoisted_27 = { class: "flex flex-col mb-3" }
const _hoisted_28 = { class: "flex flex-col mb-3 col-span-2" }
const _hoisted_29 = { class: "grid grid-cols-8 gap-3 mb-3" }
const _hoisted_30 = { class: "col-span-6 flex flex-col" }
const _hoisted_31 = { class: "col-span-2 flex flex-col mb-3" }
const _hoisted_32 = { class: "flex flex-col mb-3" }
const _hoisted_33 = { class: "flex flex-col mb-3" }
const _hoisted_34 = { class: "col flex flex-col mb-3" }
const _hoisted_35 = { class: "flex flex-col mb-3" }
const _hoisted_36 = { class: "flex flex-col mb-3" }
const _hoisted_37 = { class: "flex flex-col mb-3" }
const _hoisted_38 = { class: "grid grid-cols-1 lg:grid-cols-5 mb-3 gap-4" }
const _hoisted_39 = { class: "flex flex-col mb-3 lg:col-span-3" }
const _hoisted_40 = { class: "flex flex-col mb-3 lg:col-span-2" }
const _hoisted_41 = { class: "flex flex-col mb-3" }
const _hoisted_42 = { class: "flex flex-col mb-3" }
const _hoisted_43 = { class: "flex gap-2" }
const _hoisted_44 = { class: "grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5 pb-3" }
const _hoisted_45 = { class: "flex flex-col mb-3" }
const _hoisted_46 = { class: "flex flex-col mb-3" }
const _hoisted_47 = { class: "flex flex-col mb-3" }
const _hoisted_48 = { class: "col-span-3" }
const _hoisted_49 = { class: "whitespace-nowrap" }
const _hoisted_50 = { class: "grid grid-cols-8 gap-3 mb-3" }
const _hoisted_51 = { class: "col-span-6 flex flex-col" }
const _hoisted_52 = { class: "col-span-2 flex flex-col" }
const _hoisted_53 = { class: "flex flex-col mb-3" }
const _hoisted_54 = { class: "flex flex-col mb-3" }
const _hoisted_55 = { class: "flex flex-col mb-3" }
const _hoisted_56 = { class: "flex flex-col mb-3" }
const _hoisted_57 = { class: "flex flex-col mb-3" }
const _hoisted_58 = { class: "flex flex-col mb-3" }
const _hoisted_59 = { class: "col-start-1 flex flex-col mb-3" }
const _hoisted_60 = { class: "flex flex-col mb-3" }
const _hoisted_61 = { class: "flex flex-col mb-3" }
const _hoisted_62 = { class: "flex flex-col mb-3" }
const _hoisted_63 = { class: "flex flex-col mb-3" }
const _hoisted_64 = { class: "grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5" }
const _hoisted_65 = { class: "flex flex-col mb-3" }
const _hoisted_66 = { class: "flex flex-col mb-3" }
const _hoisted_67 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_68 = { class: "text-xs border rounded-sm p-1" }
const _hoisted_69 = { class: "ml-2" }
const _hoisted_70 = { class: "flex flex-col pb-3 border-b lg:border-none border-next-gray-md-dark" }
const _hoisted_71 = { class: "flex flex-col pb-3" }
const _hoisted_72 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_73 = { class: "mr-2" }
const _hoisted_74 = { class: "text-xs border rounded-sm p-1" }
const _hoisted_75 = { class: "ml-2" }
const _hoisted_76 = { class: "flex flex-col pb-3" }
const _hoisted_77 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_78 = { class: "text-xs border rounded-sm p-1" }
const _hoisted_79 = { class: "ml-2" }
const _hoisted_80 = { class: "flex flex-col pb-3" }
const _hoisted_81 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_82 = { class: "text-xs border rounded-sm p-1" }
const _hoisted_83 = { class: "ml-2" }
const _hoisted_84 = { class: "col-start-1 flex flex-col pb-3" }
const _hoisted_85 = ["disabled"]
const _hoisted_86 = ["disabled"]
const _hoisted_87 = { class: "flex flex-col pb-3 border-b lg:border-none border-next-gray-md-dark mb-3" }
const _hoisted_88 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_89 = { class: "text-xs border rounded-sm p-1" }
const _hoisted_90 = { class: "ml-2" }
const _hoisted_91 = { class: "flex flex-col pb-3" }
const _hoisted_92 = { class: "flex flex-grow justify-self-start bg-white" }
const _hoisted_93 = { class: "flex flex-col pt-4" }
const _hoisted_94 = { class: "flex justify-self-start bg-white" }
const _hoisted_95 = { class: "flex justify-end pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_ModalApprovaRifiuta = _resolveComponent("ModalApprovaRifiuta")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Select = _resolveComponent("Select")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_MapViewer = _resolveComponent("MapViewer")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MultiselectOption = _resolveComponent("MultiselectOption")!
  const _component_NextEditor = _resolveComponent("NextEditor")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, {
        visible: _ctx.loading || _ctx.saving
      }, null, 8, ["visible"]),
      _createVNode(_component_ModalApprovaRifiuta, {
        visible: _ctx.approvaModalVisible,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.approvaModalVisible) = $event)),
        onApprova: _cache[1] || (_cache[1] = ($event: any) => (_ctx.approvaAzienda(true))),
        onRifiuta: _cache[2] || (_cache[2] = ($event: any) => (_ctx.approvaAzienda(false)))
      }, null, 8, ["visible"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.show_error_form)
          ? (_openBlock(), _createBlock(_component_Alert, {
              key: 0,
              dismissable: true,
              onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.show_error_form = false)),
              class: "bg-next-orange drop-shadow-lg w-96 fixed top-5 right-5 z-50"
            }, {
              default: _withCtx(() => _cache[64] || (_cache[64] = [
                _createTextVNode(" Correggi gli errori di inserimento ")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Breadcrumbs, { paths: _ctx.paths }, null, 8, ["paths"]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.toApprove)
              ? (_openBlock(), _createBlock(_component_NextButton, {
                  key: 0,
                  variant: "primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.approvaModalVisible = !_ctx.approvaModalVisible)),
                  class: "w-48 text-center mr-3 py-2 px-4 m-0"
                }, {
                  default: _withCtx(() => _cache[65] || (_cache[65] = [
                    _createTextVNode(" Approva/Rifiuta ")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_NextButton, {
              variant: "outline-secondary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.back())),
              class: "w-48 hidden text-sm sm:block py-2 px-4"
            }, {
              default: _withCtx(() => _cache[66] || (_cache[66] = [
                _createTextVNode(" < Indietro ")
              ])),
              _: 1
            }),
            (!_ctx.azienda_model?.non_operativa)
              ? (_openBlock(), _createBlock(_component_NextButton, {
                  key: 1,
                  variant: "primary",
                  onClick: _ctx.save,
                  class: "w-48 text-sm sm:block py-2 px-4 ml-3"
                }, {
                  default: _withCtx(() => _cache[67] || (_cache[67] = [
                    _createTextVNode("Salva "),
                    _createElementVNode("i", { class: "spinner" }, null, -1)
                  ])),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, "Anagrafica - " + _toDisplayString(_ctx.azienda_model?.denominazione), 1),
          (_ctx.azienda_model?.non_operativa)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Non operativa "))
            : _createCommentVNode("", true)
        ]),
        (_ctx.permission_denied)
          ? (_openBlock(), _createBlock(_component_Alert, {
              key: 1,
              class: "bg-next-orange mb-5 sticky top-0 z-10"
            }, {
              default: _withCtx(() => _cache[68] || (_cache[68] = [
                _createTextVNode("Non hai i permessi sufficienti per poter modificare l'azienda, o non è stata ancora approvata. ")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _cache[70] || (_cache[70] = _createElementVNode("h6", { class: "px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray" }, "Anagrafica gamma", -1)),
          (_ctx.hasPermission('set id_gamma'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_Field, {
                  field_name: "ID gamma",
                  type: "number",
                  errors: _ctx.getErrors('id_gamma')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.azienda_model.id_gamma) = $event)),
                        type: "number",
                        class: "p-2 bg-next-gray-md-dark hover:bg-white w-full pr-7"
                      }, null, 512), [
                        [_vModelText, _ctx.azienda_model.id_gamma]
                      ]),
                      _withDirectives(_createVNode(_component_Spinner, { class: "w-5 absolute right-1" }, null, 512), [
                        [_vShow, _ctx.anagrafica_gamma_loading]
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.anagrafica_gamma?.CG16_CODICE)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("span", null, "Ragione sociale: " + _toDisplayString(_ctx.anagrafica_gamma.CG16_RAGSOANAG), 1),
                _createElementVNode("span", null, "Partita IVA: " + _toDisplayString(_ctx.anagrafica_gamma.CG16_PARTIVA), 1),
                _createElementVNode("span", null, "Codice fiscale: " + _toDisplayString(_ctx.anagrafica_gamma.CG16_CODFISCALE), 1),
                _createElementVNode("span", null, "Codice SDI: " + _toDisplayString(_ctx.anagrafica_gamma.CG1M_CODICE), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[69] || (_cache[69] = [
                _createElementVNode("span", null, "Azienda gamma non associata", -1)
              ])))
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[78] || (_cache[78] = _createElementVNode("h6", { class: "px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray" }, "Dati aziendali", -1)),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_Field, {
                field_name: "Azienda estera",
                errors: _ctx.getErrors('estera')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Select, {
                    modelValue: _ctx.azienda_model.estera,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.azienda_model.estera) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_Field, {
                field_name: "Tipo",
                errors: _ctx.getErrors('tipo')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_VueMultiselect, {
                    modelValue: _ctx.tipo_model,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tipo_model) = $event)),
                    options: _ctx.tipo_options,
                    multiple: false,
                    allowEmpty: false,
                    "close-on-select": true,
                    "clear-on-select": false,
                    selectLabel: "",
                    deselectLabel: "",
                    selectedLabel: "",
                    placeholder: "Tipo cliente",
                    class: "next-vue-multiselect-single",
                    "track-by": "id",
                    label: "text"
                  }, {
                    noResult: _withCtx(() => _cache[71] || (_cache[71] = [
                      _createTextVNode("Nessun elemento trovato.")
                    ])),
                    _: 1
                  }, 8, ["modelValue", "options"])
                ]),
                _: 1
              }, 8, ["errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_Field, {
              field_name: "Partita IVA",
              required: !_ctx.aziendaAutocomplete.selection && !_ctx.azienda_model.estera && !_ctx.azienda_model.estera && !_ctx.tipo_model?.id,
              errors: _ctx.getErrors('partita_iva')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  modelValue: _ctx.aziendaAutocomplete.selection,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.aziendaAutocomplete.selection) = $event)),
                  options: _ctx.aziendaAutocomplete.options,
                  taggable: true,
                  "clear-on-select": false,
                  preserveSearch: true,
                  onTag: _cache[10] || (_cache[10] = (value)=>_ctx.aziendaAutocomplete.add({id:-1, partita_iva:value})),
                  placeholder: "Partita IVA",
                  class: "next-vue-multiselect-single",
                  "track-by": "id",
                  label: "partita_iva",
                  selectLabel: "",
                  deselectLabel: "",
                  selectedLabel: "",
                  "internal-search": false,
                  onSearchChange: _ctx.anagraficheAutocompleteSarch
                }, {
                  option: _withCtx(({option}) => [
                    _createElementVNode("div", _hoisted_18, [
                      (option.isTag)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                            _cache[72] || (_cache[72] = _createTextVNode("Modifica partita IVA: ")),
                            _createElementVNode("span", _hoisted_20, _toDisplayString(option.label), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("span", null, [
                                _cache[73] || (_cache[73] = _createTextVNode("Azienda: ")),
                                _createElementVNode("span", _hoisted_23, _toDisplayString(option.partita_iva), 1)
                              ]),
                              _createElementVNode("span", null, [
                                _cache[74] || (_cache[74] = _createTextVNode("Ragione sociale: ")),
                                _createElementVNode("span", _hoisted_24, _toDisplayString(option.ragione_sociale), 1)
                              ]),
                              _createElementVNode("span", null, [
                                _cache[75] || (_cache[75] = _createTextVNode("CF: ")),
                                _createElementVNode("span", _hoisted_25, _toDisplayString(option.codice_fiscale), 1)
                              ])
                            ])
                          ]))
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "onSearchChange"])
              ]),
              _: 1
            }, 8, ["required", "errors"])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_Field, {
              field_name: "Codice fiscale",
              required: !_ctx.azienda_model.estera && !_ctx.azienda_model.codice_fiscale,
              modelValue: _ctx.azienda_model.codice_fiscale,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.azienda_model.codice_fiscale) = $event)),
              errors: _ctx.getErrors('codice_fiscale')
            }, null, 8, ["required", "modelValue", "errors"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_Field, {
              field_name: "Ragione sociale",
              required: !_ctx.azienda_model.ragione_sociale,
              modelValue: _ctx.azienda_model.ragione_sociale,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.azienda_model.ragione_sociale) = $event)),
              errors: _ctx.getErrors('ragione_sociale')
            }, null, 8, ["required", "modelValue", "errors"])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_MapViewer, {
              hide_map: "",
              placeId: _ctx.azienda_model.a_place_id,
              "onUpdate:placeId": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.azienda_model.a_place_id) = $event)),
              lat: _ctx.azienda_model.a_lat,
              "onUpdate:lat": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.azienda_model.a_lat) = $event)),
              lng: _ctx.azienda_model.a_lng,
              "onUpdate:lng": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.azienda_model.a_lng) = $event)),
              onAddressInformationChange: _ctx.onAziendaAddressInformationChange
            }, {
              actual: _withCtx(({actual}) => [
                _createElementVNode("p", null, [
                  _cache[76] || (_cache[76] = _createTextVNode("Selezione attuale: ")),
                  _createElementVNode("b", null, _toDisplayString(actual?.formatted_address || '----'), 1)
                ])
              ]),
              _: 1
            }, 8, ["placeId", "lat", "lng", "onAddressInformationChange"])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_Field, {
                field_name: "Sede legale via",
                required: !_ctx.azienda_model.sede_legale_via,
                modelValue: _ctx.azienda_model.sede_legale_via,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.azienda_model.sede_legale_via) = $event)),
                placeholder: "Nome via",
                errors: _ctx.getErrors('sede_legale_via')
              }, null, 8, ["required", "modelValue", "errors"])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_Field, {
                field_name: "numero",
                required: !_ctx.azienda_model.sede_legale_numero,
                modelValue: _ctx.azienda_model.sede_legale_numero,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.azienda_model.sede_legale_numero) = $event)),
                errors: _ctx.getErrors('sede_legale_numero'),
                placeholder: "00"
              }, null, 8, ["required", "modelValue", "errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_Field, {
              required: !_ctx.sl.na_selection,
              field_name: "Sede legale nazione",
              errors: _ctx.getErrors('sede_legale_nazione_id')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  modelValue: _ctx.sl.na_selection,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.sl.na_selection) = $event)),
                  options: _ctx.sl.na_options,
                  placeholder: "Nazione",
                  class: "next-vue-multiselect-single",
                  "track-by": "id",
                  label: "codice",
                  selectLabel: "",
                  deselectLabel: "",
                  selectedLabel: "",
                  "internal-search": false,
                  onSearchChange: _ctx.sl.na_search
                }, {
                  option: _withCtx(({option}) => [
                    _createTextVNode(_toDisplayString(option.codice) + " - " + _toDisplayString(option.nome), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "onSearchChange"])
              ]),
              _: 1
            }, 8, ["required", "errors"])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_Field, {
              field_name: "Sede legale cap",
              required: !_ctx.azienda_model.sede_legale_cap,
              modelValue: _ctx.azienda_model.sede_legale_cap,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.azienda_model.sede_legale_cap) = $event)),
              errors: _ctx.getErrors('sede_legale_cap'),
              placeholder: "CAP"
            }, null, 8, ["required", "modelValue", "errors"])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_34, [
            _createVNode(_component_Field, {
              errors: _ctx.getErrors('sede_legale_provincia_id'),
              required: !_ctx.sl.pa_selection,
              field_name: "Sede legale provincia"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  modelValue: _ctx.sl.pa_selection,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.sl.pa_selection) = $event)),
                  options: _ctx.sl.pa_options,
                  onTag: _cache[21] || (_cache[21] = (value)=>_ctx.sl.pa_add({id:-1, nome:value})),
                  placeholder: "Prov.",
                  class: "next-vue-multiselect-single",
                  "track-by": "id",
                  label: "codice",
                  selectLabel: "",
                  deselectLabel: "",
                  selectedLabel: "",
                  "internal-search": false,
                  onSearchChange: _ctx.sl.pa_search
                }, null, 8, ["modelValue", "options", "onSearchChange"])
              ]),
              _: 1
            }, 8, ["errors", "required"])
          ], 512), [
            [_vShow, _ctx.sl.isNazioneItalia]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_35, [
            _createVNode(_component_Field, {
              errors: _ctx.getErrors('sede_legale_comune_id'),
              required: !_ctx.sl.ca_selection,
              field_name: "Sede legale comune"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  modelValue: _ctx.sl.ca_selection,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.sl.ca_selection) = $event)),
                  options: _ctx.sl.ca_options,
                  onTag: _cache[23] || (_cache[23] = (value)=>_ctx.sl.ca_add({id:-1, nome:value})),
                  placeholder: "Comune",
                  class: "next-vue-multiselect-single",
                  "track-by": "id",
                  label: "nome",
                  selectLabel: "",
                  deselectLabel: "",
                  selectedLabel: "",
                  "internal-search": false,
                  onSearchChange: _ctx.sl.ca_search
                }, null, 8, ["modelValue", "options", "onSearchChange"])
              ]),
              _: 1
            }, 8, ["errors", "required"])
          ], 512), [
            [_vShow, _ctx.sl.isNazioneItalia]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_36, [
            _createVNode(_component_Field, {
              field_name: "Sede legale regione estera",
              required: !_ctx.azienda_model.sede_legale_regione_estero,
              modelValue: _ctx.azienda_model.sede_legale_regione_estero,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.azienda_model.sede_legale_regione_estero) = $event)),
              errors: _ctx.getErrors('sede_legale_regione_estero'),
              placeholder: "Regione estera"
            }, null, 8, ["required", "modelValue", "errors"])
          ], 512), [
            [_vShow, !_ctx.sl.isNazioneItalia]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_37, [
            _createVNode(_component_Field, {
              field_name: "Sede legale città estera",
              required: !_ctx.azienda_model.sede_legale_citta_estero,
              modelValue: _ctx.azienda_model.sede_legale_citta_estero,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.azienda_model.sede_legale_citta_estero) = $event)),
              errors: _ctx.getErrors('sede_legale_citta_estero'),
              placeholder: "Città estera"
            }, null, 8, ["required", "modelValue", "errors"])
          ], 512), [
            [_vShow, !_ctx.sl.isNazioneItalia]
          ]),
          _cache[79] || (_cache[79] = _createElementVNode("div", null, null, -1)),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_Field, {
                field_name: "Numero di dipendenti",
                modelValue: _ctx.azienda_model.numero_dipendenti,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.azienda_model.numero_dipendenti) = $event)),
                type: "number",
                errors: _ctx.getErrors('numero_dipendenti'),
                placeholder: "Numero di dipendenti"
              }, null, 8, ["modelValue", "errors"])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_Field, {
                field_name: "Dipendenti (Anno)",
                modelValue: _ctx.azienda_model.dipendenti,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.azienda_model.dipendenti) = $event)),
                type: "number",
                errors: _ctx.getErrors('dipendenti'),
                placeholder: "Anno"
              }, null, 8, ["modelValue", "errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_component_Field, {
              field_name: "Ricavi",
              modelValue: _ctx.azienda_model.ricavi,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.azienda_model.ricavi) = $event)),
              type: "number",
              errors: _ctx.getErrors('ricavi'),
              placeholder: "Ricavi"
            }, null, 8, ["modelValue", "errors"])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _cache[77] || (_cache[77] = _createElementVNode("div", { class: "font-bold pb-2" }, "Data chiusura bilancio", -1)),
            _createElementVNode("div", _hoisted_43, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.azienda_model.data_chiusura_bilancio) = $event)),
                type: "date",
                class: "p-2 bg-next-gray-md w-full"
              }, null, 512), [
                [_vModelText, _ctx.azienda_model.data_chiusura_bilancio]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _cache[81] || (_cache[81] = _createElementVNode("h6", { class: "px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray" }, "Denominazione", -1)),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_Field, {
              field_name: "Denominazione",
              required: true,
              modelValue: _ctx.azienda_model.denominazione,
              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.azienda_model.denominazione) = $event)),
              errors: _ctx.getErrors('denominazione')
            }, null, 8, ["modelValue", "errors"])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_Field, {
              field_name: "Sito web",
              required: true,
              modelValue: _ctx.azienda_model.sito,
              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.azienda_model.sito) = $event)),
              errors: _ctx.getErrors('sito')
            }, null, 8, ["modelValue", "errors"])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_Field, {
              field_name: "Gruppo di appartenenza",
              modelValue: _ctx.azienda_model.gruppo_di_appartenenza,
              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.azienda_model.gruppo_di_appartenenza) = $event)),
              errors: _ctx.getErrors('gruppo_di_appartenenza')
            }, null, 8, ["modelValue", "errors"])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_component_MapViewer, {
              placeId: _ctx.azienda_model.place_id,
              "onUpdate:placeId": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.azienda_model.place_id) = $event)),
              lat: _ctx.azienda_model.lat,
              "onUpdate:lat": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.azienda_model.lat) = $event)),
              lng: _ctx.azienda_model.lng,
              "onUpdate:lng": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.azienda_model.lng) = $event)),
              onAddressInformationChange: _ctx.onAddressInformationChange
            }, {
              actual: _withCtx(({actual}) => [
                _createElementVNode("p", _hoisted_49, [
                  _cache[80] || (_cache[80] = _createTextVNode("Selezione attuale: ")),
                  _createElementVNode("b", null, _toDisplayString(actual?.formatted_address || '----'), 1)
                ])
              ]),
              _: 1
            }, 8, ["placeId", "lat", "lng", "onAddressInformationChange"])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createVNode(_component_Field, {
                field_name: "Sede operativa via",
                modelValue: _ctx.azienda_model.sede_operativa_via,
                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.azienda_model.sede_operativa_via) = $event)),
                errors: _ctx.getErrors('sede_operativa_via'),
                placeholder: "Nome via"
              }, null, 8, ["modelValue", "errors"])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createVNode(_component_Field, {
                field_name: "numero",
                modelValue: _ctx.azienda_model.sede_operativa_numero,
                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.azienda_model.sede_operativa_numero) = $event)),
                errors: _ctx.getErrors('sede_operativa_numero'),
                placeholder: "00"
              }, null, 8, ["modelValue", "errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_component_Field, {
              required: false,
              field_name: "Sede operativa nazione",
              errors: _ctx.getErrors('sede_operativa_nazione_id')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  modelValue: _ctx.so.na_selection,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.so.na_selection) = $event)),
                  options: _ctx.so.na_options,
                  placeholder: "Nazione",
                  class: "next-vue-multiselect-single",
                  "track-by": "id",
                  label: "codice",
                  selectLabel: "",
                  deselectLabel: "",
                  selectedLabel: "",
                  "internal-search": false,
                  onSearchChange: _ctx.so.na_search
                }, {
                  option: _withCtx(({option}) => [
                    _createTextVNode(_toDisplayString(option.codice) + " - " + _toDisplayString(option.nome), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "onSearchChange"])
              ]),
              _: 1
            }, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createVNode(_component_Field, {
              field_name: "Sede operativa cap",
              modelValue: _ctx.azienda_model.sede_operativa_cap,
              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.azienda_model.sede_operativa_cap) = $event)),
              errors: _ctx.getErrors('sede_operativa_cap'),
              placeholder: "CAP"
            }, null, 8, ["modelValue", "errors"])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_55, [
            _createVNode(_component_Field, {
              required: false,
              field_name: "Sede operativa provincia",
              errors: _ctx.getErrors('sede_operativa_provincia_id')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  modelValue: _ctx.so.pa_selection,
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.so.pa_selection) = $event)),
                  options: _ctx.so.pa_options,
                  placeholder: "Prov.",
                  class: "next-vue-multiselect-single",
                  "track-by": "id",
                  label: "codice",
                  selectLabel: "",
                  deselectLabel: "",
                  selectedLabel: "",
                  "internal-search": false,
                  onSearchChange: _ctx.so.pa_search
                }, null, 8, ["modelValue", "options", "onSearchChange"])
              ]),
              _: 1
            }, 8, ["errors"])
          ], 512), [
            [_vShow, _ctx.so.isNazioneItalia]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_56, [
            _createVNode(_component_Field, {
              errors: _ctx.getErrors('sede_operativa_comune_id'),
              field_name: "Sede operativa comune"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  modelValue: _ctx.so.ca_selection,
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.so.ca_selection) = $event)),
                  options: _ctx.so.ca_options,
                  onTag: _cache[42] || (_cache[42] = (value)=>_ctx.so.ca_add({id:-1, nome:value})),
                  placeholder: "Comune",
                  class: "next-vue-multiselect-single",
                  "track-by": "id",
                  label: "nome",
                  selectLabel: "",
                  deselectLabel: "",
                  selectedLabel: "",
                  "internal-search": false,
                  onSearchChange: _ctx.so.ca_search
                }, null, 8, ["modelValue", "options", "onSearchChange"])
              ]),
              _: 1
            }, 8, ["errors"])
          ], 512), [
            [_vShow, _ctx.so.isNazioneItalia]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_57, [
            _createVNode(_component_Field, {
              field_name: "Sede operativa regione estera",
              modelValue: _ctx.azienda_model.sede_operativa_regione_estero,
              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.azienda_model.sede_operativa_regione_estero) = $event)),
              errors: _ctx.getErrors('sede_operativa_regione_estero'),
              placeholder: "Regione estera"
            }, null, 8, ["modelValue", "errors"])
          ], 512), [
            [_vShow, !_ctx.so.isNazioneItalia]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_58, [
            _createVNode(_component_Field, {
              field_name: "Sede operativa città estera",
              modelValue: _ctx.azienda_model.sede_operativa_citta_estero,
              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.azienda_model.sede_operativa_citta_estero) = $event)),
              errors: _ctx.getErrors('sede_operativa_citta_estero'),
              placeholder: "Città estera"
            }, null, 8, ["modelValue", "errors"])
          ], 512), [
            [_vShow, !_ctx.so.isNazioneItalia]
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_component_Field, {
              field_name: "Email",
              modelValue: _ctx.azienda_model.email,
              "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.azienda_model.email) = $event)),
              type: "email",
              errors: _ctx.getErrors('email'),
              placeholder: "Email"
            }, null, 8, ["modelValue", "errors"])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createVNode(_component_Field, {
              field_name: "Email pec",
              modelValue: _ctx.azienda_model.pec,
              "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.azienda_model.pec) = $event)),
              type: "email",
              errors: _ctx.getErrors('pec'),
              placeholder: "Email pec"
            }, null, 8, ["modelValue", "errors"])
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createVNode(_component_Field, {
              field_name: "Telefono 1",
              modelValue: _ctx.azienda_model.telefono_1,
              "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.azienda_model.telefono_1) = $event)),
              errors: _ctx.getErrors('telefono_1'),
              placeholder: "Telefono"
            }, null, 8, ["modelValue", "errors"])
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createVNode(_component_Field, {
              field_name: "Telefono 2",
              modelValue: _ctx.azienda_model.telefono_2,
              "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.azienda_model.telefono_2) = $event)),
              errors: _ctx.getErrors('telefono_2'),
              placeholder: "Telefono"
            }, null, 8, ["modelValue", "errors"])
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createVNode(_component_Field, {
              field_name: "Fax",
              modelValue: _ctx.azienda_model.fax,
              "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.azienda_model.fax) = $event)),
              errors: _ctx.getErrors('fax'),
              placeholder: "Fax"
            }, null, 8, ["modelValue", "errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_64, [
          _cache[90] || (_cache[90] = _createElementVNode("h6", { class: "px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray" }, "Assegnazioni cliente", -1)),
          _createVNode(_component_router_link, {
            to: {name:'StoricoCliente', params:{id:_ctx.id}},
            class: "px-3 -translate-y-1/2 -translate-x-3 top-0 right-0 absolute bg-next-light-gray"
          }, {
            default: _withCtx(() => _cache[82] || (_cache[82] = [
              _createTextVNode(" Storico clienti")
            ])),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_65, [
            _createVNode(_component_Field, {
              field_name: "Settore commerciale",
              required: true,
              modelValue: _ctx.settoriSelections,
              "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.settoriSelections) = $event)),
              errors: _ctx.getErrors('settori')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  searchable: true,
                  trackBy: "descrizione",
                  label: "descrizione",
                  modelValue: _ctx.settoriSelections,
                  "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.settoriSelections) = $event)),
                  options: _ctx.settoriOptions,
                  multiple: true,
                  taggable: false,
                  "close-on-select": false,
                  "clear-on-select": false,
                  class: "next-vue-multiselect",
                  placeholder: "Settore commerciale",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona",
                  tagPlaceholder: "Aggiungi settore"
                }, {
                  tag: _withCtx(({option, remove}) => [
                    _createVNode(_component_MultiselectOption, {
                      onRemove: ($event: any) => (remove(option))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(option.descrizione), 1)
                      ]),
                      _: 2
                    }, 1032, ["onRemove"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ]),
              _: 1
            }, 8, ["modelValue", "errors"])
          ]),
          _createElementVNode("div", _hoisted_66, [
            _createVNode(_component_Field, {
              field_name: "Lavoro new business",
              errors: _ctx.getErrors('lavoro_new_business')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  modelValue: _ctx.buAutocomplete.selection,
                  "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.buAutocomplete.selection) = $event)),
                  options: _ctx.buAutocomplete.options,
                  multiple: true,
                  disabled: !_ctx.hasPermission('set lavoro_new_business'),
                  onSearchChange: _ctx.buAutocomplete.search,
                  "close-on-select": false,
                  "clear-on-select": false,
                  placeholder: "Lavoro new business",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona",
                  tagPlaceholder: "Lavoro new business",
                  class: "next-vue-multiselect",
                  "track-by": "id",
                  label: "name"
                }, {
                  noResult: _withCtx(() => _cache[83] || (_cache[83] = [
                    _createTextVNode("Nessun elemento trovato.")
                  ])),
                  tag: _withCtx(({option, remove}) => [
                    _createVNode(_component_MultiselectOption, {
                      onRemove: ($event: any) => (remove(option))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_67, _toDisplayString(option.label || ' '), 1),
                        _createElementVNode("span", null, _toDisplayString(option.nome), 1)
                      ]),
                      _: 2
                    }, 1032, ["onRemove"])
                  ]),
                  option: _withCtx(({option}) => [
                    _createElementVNode("span", null, [
                      _createElementVNode("span", _hoisted_68, _toDisplayString(option.label), 1),
                      _createElementVNode("span", _hoisted_69, _toDisplayString(option.nome), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "disabled", "onSearchChange"])
              ]),
              _: 1
            }, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_70, [
            _createVNode(_component_Field, {
              field_name: "Origine lead",
              required: false,
              errors: _ctx.getErrors('origine_lead')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  modelValue: _ctx.origine_lead_model,
                  "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.origine_lead_model) = $event)),
                  options: _ctx.origine_lead_options,
                  "close-on-select": true,
                  "clear-on-select": false,
                  placeholder: "Origine lead",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona",
                  class: "next-vue-multiselect-single",
                  "track-by": "id",
                  label: "text"
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_71, [
            _createVNode(_component_Field, {
              field_name: "Responsabile New Business",
              errors: _ctx.getErrors('responsabile_id')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  onSearchChange: _ctx.responsabileAutocomplete.search,
                  loading: _ctx.responsabileAutocomplete.isLoading,
                  options: _ctx.responsabileAutocomplete.options,
                  modelValue: _ctx.responsabileAutocomplete.selection,
                  "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.responsabileAutocomplete.selection) = $event)),
                  disabled: !_ctx.hasPermission('assegnazione_utenti_crm'),
                  "track-by": "id",
                  label: "name",
                  placeholder: "Responsabile new business",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona",
                  class: "next-vue-multiselect-single"
                }, {
                  noResult: _withCtx(() => _cache[84] || (_cache[84] = [
                    _createTextVNode("Nessun elemento trovato.")
                  ])),
                  singleLabel: _withCtx(({option}) => [
                    _createElementVNode("span", null, [
                      _createElementVNode("span", _hoisted_72, _toDisplayString(option.bu_label), 1),
                      _createElementVNode("span", _hoisted_73, _toDisplayString(option.name), 1)
                    ])
                  ]),
                  option: _withCtx(({option}) => [
                    _createElementVNode("span", null, [
                      _createElementVNode("span", _hoisted_74, _toDisplayString(option.bu_label), 1),
                      _createElementVNode("span", _hoisted_75, _toDisplayString(option.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["onSearchChange", "loading", "options", "modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_76, [
            _createVNode(_component_Field, {
              field_name: "Presentazione",
              errors: _ctx.getErrors('presentazioni')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  modelValue: _ctx.presentazioneAutocomplete.selection,
                  "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.presentazioneAutocomplete.selection) = $event)),
                  options: _ctx.presentazioneAutocomplete.options,
                  multiple: true,
                  onSearchChange: _ctx.presentazioneAutocomplete.search,
                  disabled: !_ctx.hasPermission('assegnazione_utenti_crm'),
                  "close-on-select": false,
                  "clear-on-select": false,
                  placeholder: "Presentazione",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona",
                  class: "next-vue-multiselect",
                  "track-by": "id",
                  label: "name"
                }, {
                  noResult: _withCtx(() => _cache[85] || (_cache[85] = [
                    _createTextVNode("Nessun elemento trovato.")
                  ])),
                  tag: _withCtx(({option, remove}) => [
                    _createVNode(_component_MultiselectOption, {
                      onRemove: ($event: any) => (remove(option))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_77, _toDisplayString(option.bu_label || ' '), 1),
                        _createElementVNode("span", null, _toDisplayString(option.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["onRemove"])
                  ]),
                  option: _withCtx(({option}) => [
                    _createElementVNode("span", null, [
                      _createElementVNode("span", _hoisted_78, _toDisplayString(option.bu_label), 1),
                      _createElementVNode("span", _hoisted_79, _toDisplayString(option.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "onSearchChange", "disabled"])
              ]),
              _: 1
            }, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_80, [
            _createVNode(_component_Field, {
              field_name: "Head of Client / Client Director",
              errors: _ctx.getErrors('accounts')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  modelValue: _ctx.accountAutocomplete.selection,
                  "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.accountAutocomplete.selection) = $event)),
                  options: _ctx.accountAutocomplete.options,
                  multiple: true,
                  onSearchChange: _ctx.accountAutocomplete.search,
                  disabled: !_ctx.hasPermission('assegnazione_utenti_crm'),
                  "close-on-select": false,
                  "clear-on-select": false,
                  placeholder: "Head of Client / Client Director",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona",
                  tagPlaceholder: "Aggiungi Head of Client / Client Director",
                  class: "next-vue-multiselect",
                  "track-by": "id",
                  label: "name"
                }, {
                  noResult: _withCtx(() => _cache[86] || (_cache[86] = [
                    _createTextVNode("Nessun elemento trovato.")
                  ])),
                  tag: _withCtx(({option, remove}) => [
                    _createVNode(_component_MultiselectOption, {
                      onRemove: ($event: any) => (remove(option))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_81, _toDisplayString(option.bu_label || ' '), 1),
                        _createElementVNode("span", null, _toDisplayString(option.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["onRemove"])
                  ]),
                  option: _withCtx(({option}) => [
                    _createElementVNode("span", null, [
                      _createElementVNode("span", _hoisted_82, _toDisplayString(option.bu_label), 1),
                      _createElementVNode("span", _hoisted_83, _toDisplayString(option.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "onSearchChange", "disabled"])
              ]),
              _: 1
            }, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_84, [
            _createVNode(_component_Field, {
              field_name: "Necessità iscrizione albo fornitori",
              errors: _ctx.getErrors('albo_fornitori')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  modelValue: _ctx.albo_fornitori_model,
                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.albo_fornitori_model) = $event)),
                  options: _ctx.albo_fornitori_options,
                  multiple: false,
                  allowEmpty: false,
                  "close-on-select": true,
                  "clear-on-select": false,
                  placeholder: "Albo fornitori",
                  class: "next-vue-multiselect-single",
                  "track-by": "id",
                  label: "text"
                }, {
                  noResult: _withCtx(() => _cache[87] || (_cache[87] = [
                    _createTextVNode("Nessun elemento trovato.")
                  ])),
                  _: 1
                }, 8, ["modelValue", "options"])
              ]),
              _: 1
            }, 8, ["errors"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["flex flex-col pb-3", {'hidden': _ctx.azienda_model.albo_fornitori!=='Si'}])
          }, [
            _createVNode(_component_Field, {
              field_name: "Data limite iscrizione albo fornitori",
              errors: _ctx.getErrors('data_albo_fornitori')
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  disabled: _ctx.azienda_model.albo_fornitori !== 'Si',
                  "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.azienda_model.data_albo_fornitori) = $event)),
                  type: "date",
                  class: "flex-grow p-7px bg-next-gray-md-dark group-hover:bg-white"
                }, null, 8, _hoisted_85), [
                  [_vModelText, _ctx.azienda_model.data_albo_fornitori]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["flex flex-col pb-3", {'hidden': _ctx.azienda_model.albo_fornitori!=='Si'}])
          }, [
            _createVNode(_component_Field, {
              field_name: "Referente",
              errors: _ctx.getErrors('referente_id')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  modelValue: _ctx.referenteAutocomplete.selection,
                  "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.referenteAutocomplete.selection) = $event)),
                  options: _ctx.referenteAutocomplete.options,
                  onSearchChange: _ctx.referenteAutocomplete.search,
                  "close-on-select": true,
                  "clear-on-select": true,
                  placeholder: "Referente",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona",
                  class: "next-vue-multiselect-single",
                  "track-by": "id",
                  label: "full_name"
                }, {
                  noResult: _withCtx(() => _cache[88] || (_cache[88] = [
                    _createTextVNode("Nessun elemento trovato.")
                  ])),
                  _: 1
                }, 8, ["modelValue", "options", "onSearchChange"])
              ]),
              _: 1
            }, 8, ["errors"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["flex flex-col pb-3 col-span-3", {'hidden': _ctx.azienda_model.albo_fornitori!=='Si'}])
          }, [
            _createVNode(_component_Field, {
              field_name: "Link portale di iscrizione",
              errors: _ctx.getErrors('link_portale')
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  disabled: _ctx.azienda_model.albo_fornitori !== 'Si',
                  "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.azienda_model.link_portale) = $event)),
                  type: "url",
                  class: "p-2 bg-next-gray-md-dark hover:bg-white w-full"
                }, null, 8, _hoisted_86), [
                  [_vModelText, _ctx.azienda_model.link_portale]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ], 2),
          _createElementVNode("div", _hoisted_87, [
            _createVNode(_component_Field, {
              field_name: "Non interessato",
              required: false,
              errors: _ctx.getErrors('non_interessato_ids')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  modelValue: _ctx.nonInteressato.selection,
                  "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.nonInteressato.selection) = $event)),
                  options: _ctx.nonInteressato.options,
                  multiple: true,
                  "internal-search": true,
                  "close-on-select": false,
                  "clear-on-select": false,
                  placeholder: "Non interessato",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona",
                  class: "next-vue-multiselect",
                  "track-by": "id",
                  label: "nome"
                }, {
                  noResult: _withCtx(() => _cache[89] || (_cache[89] = [
                    _createTextVNode("Nessun elemento trovato.")
                  ])),
                  tag: _withCtx(({option, remove}) => [
                    _createVNode(_component_MultiselectOption, {
                      onRemove: ($event: any) => (remove(option))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_88, _toDisplayString(option.label || ' '), 1),
                        _createElementVNode("span", null, _toDisplayString(option.nome), 1)
                      ]),
                      _: 2
                    }, 1032, ["onRemove"])
                  ]),
                  option: _withCtx(({option}) => [
                    _createElementVNode("span", null, [
                      _createElementVNode("span", _hoisted_89, _toDisplayString(option.label), 1),
                      _createElementVNode("span", _hoisted_90, _toDisplayString(option.nome), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_91, [
            _cache[91] || (_cache[91] = _createElementVNode("div", { class: "pb-2 font-bold text-sm" }, "Note di presentazione", -1)),
            _createElementVNode("div", _hoisted_92, [
              _createVNode(_component_NextEditor, {
                modelValue: _ctx.azienda_model.note_di_presentazione,
                "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.azienda_model.note_di_presentazione) = $event)),
                class: "limit_tiny_mce"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_93, [
            _cache[92] || (_cache[92] = _createElementVNode("div", { class: "pb-2 font-bold text-sm" }, "Note", -1)),
            _createElementVNode("div", _hoisted_94, [
              _createVNode(_component_NextEditor, {
                modelValue: _ctx.azienda_model.note,
                "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.azienda_model.note) = $event))
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_95, [
        (!_ctx.azienda_model?.non_operativa)
          ? (_openBlock(), _createBlock(_component_NextButton, {
              key: 0,
              variant: "primary",
              onClick: _ctx.save,
              class: "w-48 text-sm sm:block py-2 px-4 ml-3"
            }, {
              default: _withCtx(() => _cache[93] || (_cache[93] = [
                _createTextVNode("Salva "),
                _createElementVNode("i", { class: "spinner" }, null, -1)
              ])),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}